import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

import { sizeToken } from "../../Internals/ThemeProvider/CandyTheme/ThemeBuilder/ICandyTheme";
import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

import loader from "./loader.svg";

export const Root = styled.span(props => ({
    display: "inline-flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "stretch",
    backgroundColor: theme(props).keyPalette.panelBackgroundColor,
}));

export const CompanyName = styled.div(props => ({
    ...props.theme.candy.typography.primary.css(),
    lineHeight: "18px",
    padding: `0 0 ${sizeToken(0.5)}px ${sizeToken(0.5)}px`,
}));

export const SearchContainer = styled.div(props => ({
    ...props.theme.candy.typography.primary.css(),
    ...props.theme.candy.typography.secondary.css(),
    lineHeight: "18px",
    padding: `0 0 ${sizeToken(0.5)}px ${sizeToken(0.5)}px`,
    display: "flex",
}));

export const DontWork = styled.div(props => ({
    ...props.theme.candy.typography.primary.css(),
    ...props.theme.candy.typography.secondary.css(),
    lineHeight: "18px",
    padding: `0 0 ${sizeToken(0.5)}px ${sizeToken(0.5)}px`,
    display: "flex",
}));

export const NotFoundContainer = styled.div(props => ({
    ...props.theme.candy.typography.primary.css(),
    ...props.theme.candy.typography.secondary.css(),
    lineHeight: "18px",
    padding: `0 0 ${sizeToken(0.5)}px ${sizeToken(0.5)}px`,
    display: "flex",
}));

export const ChildrenContainer = styled.div({
    display: "flex",
});

const infiniteSpinning = keyframes(`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`);

export const LoadingIcon = styled.div({
    animation: `${infiniteSpinning} 1s cubic-bezier(0.55, 0.6, 0.55, 0.6) infinite`,
    alignSelf: "center",
    width: 16,
    height: 16,
    background: `url(${loader})`,
    backgroundSize: "cover",
    marginRight: 5,
});
